import React, { ReactNode } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Card } from 'shared/components';

export interface DataItem {
  label: string;
  value: string | number | ReactNode;
}

interface DataDisplayProps {
  title?: string;
  items: DataItem[];
  showCard?: boolean;
  emptyMessage?: string;
  labelWidth?: number;
}

const DataItemRow = ({
  label,
  value,
  labelWidth = 4,
}: DataItem & { labelWidth?: number }) => (
  <Row className="mb-2">
    <Col xs={12} md={labelWidth}>
      {label}:
    </Col>
    <Col>{value} </Col>
  </Row>
);

export const DataDisplay: React.FC<DataDisplayProps> = ({
  title,
  items,
  showCard = true,
  emptyMessage = 'No hay datos para mostrar',
  labelWidth = 4,
}) => {
  const content = (
    <>
      {items && items.length > 0 ? (
        items.map((item, index) => (
          <DataItemRow
            key={`data-item-${index}`}
            label={item.label}
            value={item.value}
            labelWidth={labelWidth}
          />
        ))
      ) : (
        <p>{emptyMessage}</p>
      )}
    </>
  );

  if (!showCard) {
    return content;
  }

  return (
    <Card>
      {title && <Card.Title>{title}</Card.Title>}
      <Card.Body $padding>{content}</Card.Body>
    </Card>
  );
};
